import React, { useEffect } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Camera, X } from "lucide-react";

export default function ItemQRScanner({ onClose, onScanned }) {
  useEffect(() => {
    let scanner;
    const start = async () => {
      try {
        scanner = new Html5Qrcode("item-qr-reader-box");
        await scanner.start({ facingMode: "environment" }, { fps: 10, qrbox: 220 },
          (decoded) => {
            const m = decoded.match(/magazzino-pubblico\/([A-Za-z0-9_-]+)(?:\?taglia=([^&]+))?/i);
            if (m) {
              const itemId = m[1];
              const size = m[2] ? decodeURIComponent(m[2]) : null;
              scanner.stop().then(() => onScanned(itemId, size));
            }
          }, () => {});
      } catch (e) {
        if (process.env.NODE_ENV !== "production") console.warn("QR scanner error:", e);
        toast.error("Camera non disponibile. Usa la ricerca manuale.");
        onClose();
      }
    };
    start();
    return () => { if (scanner?.isScanning) scanner.stop().catch(() => {}); };
  }, [onClose, onScanned]);

  return (
    <div className="fixed inset-0 bg-slate-900/90 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg p-4 max-w-md w-full">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-display font-bold flex items-center gap-2"><Camera className="w-4 h-4" /> Scansiona QR articolo</h3>
          <Button variant="outline" size="sm" onClick={onClose}><X className="w-4 h-4" /></Button>
        </div>
        <div id="item-qr-reader-box" className="w-full" />
        <p className="text-xs text-slate-500 mt-3 text-center">Inquadra il QR dell'articolo/taglia da consegnare.</p>
      </div>
    </div>
  );
}
